import { tableChartTransformation } from './charts';
import { defaultTransformation } from './default-transformation';
export var transformChronological = function (_a, _b, visualization) {
    var query = _a.query, result = _a.result;
    var dateModifier = _b.dateModifier;
    var enableTableFormatter = (query === null || query === void 0 ? void 0 : query.analysis_type) && (query === null || query === void 0 ? void 0 : query.event_collection) &&
        visualization === 'table';
    return enableTableFormatter
        ? tableChartTransformation(query, result, dateModifier)
        : defaultTransformation(result, dateModifier);
};
